import React, { useEffect, useState } from 'react';
import { GeographicSearchField } from '../lib/utils/humanResourcesFilters';
import ButtonsFilter from './ButtonsFilter';

type SearchBarProps = {
  activeField: GeographicSearchField;
  activeValue: string;
  onModeChange: (field: GeographicSearchField) => void;
  onSearch: (field: GeographicSearchField, value: string) => void;
  onReset: () => void;
};

const searchOptions: Array<{ value: GeographicSearchField; label: string }> = [
  { value: 'citta', label: 'Città' },
  { value: 'provincia', label: 'Provincia' },
];

const SearchBar: React.FC<SearchBarProps> = ({ activeField, activeValue, onModeChange, onSearch, onReset }) => {
  const [field, setField] = useState<GeographicSearchField>(activeField);
  const [value, setValue] = useState(activeValue);
  const [error, setError] = useState('');

  useEffect(() => {
    if (activeValue) setField(activeField);
    setValue(activeValue);
    setError('');
  }, [activeField, activeValue]);

  const handleFieldChange = (nextField: GeographicSearchField) => {
    if (nextField === field) return;
    setField(nextField);
    setValue('');
    setError('');
    onModeChange(nextField);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (!value.trim()) return;

    if (field === 'provincia' && !/^[A-Z]{2}$/.test(value.trim().toUpperCase())) {
      setError('La provincia deve contenere 2 lettere (es. BA, MI).');
      return;
    }

    onSearch(field, field === 'provincia' ? value.trim().toUpperCase() : value.trim());
  };

  const handleReset = () => {
    setValue('');
    setField('citta');
    setError('');
    onReset();
  };

  return (
    <form onSubmit={handleSubmit} className="flex w-full max-w-3xl items-center mx- gap-2p-2 shadow-sm bg-white">
      <div className="flex w-full items-start flex-col flex-column px-6">
        <ButtonsFilter text="Ricerca per residenza/domicilio">
          <select
            aria-label="Modalità ricerca geografica"
            value={field}
            onChange={(event) => handleFieldChange(event.target.value as GeographicSearchField)}
            className="border p-2 rounded-md">
            {searchOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          <input
            aria-label="Valore ricerca geografica"
            type="text"
            value={value}
            onChange={(event) => {
              const nextValue = field === 'provincia' ? event.target.value.toUpperCase() : event.target.value;
              if (field === 'provincia' && !/^[A-Z]{0,2}$/.test(nextValue)) return;
              setValue(nextValue);
            }}
            placeholder={field === 'provincia' ? 'Sigla (es. BS)' : 'Nome per esteso (es. Brescia)'}
            className="flex-grow min-w-[280px] border p-2 rounded-md"
          />

          <button type="submit" className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark">
            Cerca
          </button>
          <button type="button" onClick={handleReset} className="bg-gray-400 text-white px-4 py-2 rounded">
            Reset
          </button>
          {error && <p className="text-red text-xs mt-2">{error}</p>}
        </ButtonsFilter>
      </div>
    </form>
  );
};

export default SearchBar;
